
import withAuth from "../../withAuth";
import { useEffect, useState } from "react";
import { Titillium_Web } from "next/font/google";
import withPlatformLayout from "./withPlatformLayout";
import PageLoad from "../../PageLoad";
import { Input } from "../../Input";
import { Button } from "../../Button";
import { EMAIL_RE, IAuthUser, PLATFORM_ROUTE, api } from "../../helpers";
import { Select } from "../../Select";
import { useRouter } from "next/router";
import { rudderStackTrack } from "../../Track";
import ACTIONS from "../../EventLibrary";
import React from "react";
import { Card, Flex } from "@radix-ui/themes";
import { BreadCrumb } from "../../BreadCrumb";
const tw = Titillium_Web({ weight: ["300", "400"], subsets: ["latin"] });

const SupportPage = ({ user, token, busy, handleToast }) => {
    const [supportData, setData] = useState({
        subject: "",
        type: "API",
        name: "",
        billing_email: "",
        endpoint: "",
        chain: "",
        message: "",
    });
    const [load, setLoad] = useState<boolean>(false);
    const [submitted, setSubmit] = useState<boolean>(false);
    const router = useRouter();


    useEffect(()=>{
        setData({...supportData,    
            ...{subject: "",
                name: "",
                billing_email: "",
                endpoint: "",
                chain: "",
                message: "",}  
        });
    },[supportData.type]);

    const _user = user.match({
        None: () => null,
        Some: (x) => x
    });

    if(!busy){
        user.match({
            None: () => null,
            Some: (user: IAuthUser) => {
                if (!user.group?.is_paid) {
                    router.push(`/${PLATFORM_ROUTE}/billing/`);
                }
            }
        });
    }


    const _createSupportFormNotOk = () => {
        if (supportData.subject.length === 0) {
            return true;
        }
        if (supportData.message.length === 0) {
            return true;
        }
        if (supportData.type === "BILLING" && supportData.billing_email.length < 5) {
            return true;
        }
        if (supportData.type === "API" && supportData.endpoint.length === 0) {
            return true;
        }
        if (supportData.type === "API" && supportData.chain.length === 0) {
            return true;
        }

        const validEmail = EMAIL_RE.test(String(supportData.billing_email).toLowerCase());
        if (supportData.type === "BILLING" && !validEmail) {
            return true;
        }

        return false;
    };

    const handleRudderStack = (email, display_name, message, action) => {
        rudderStackTrack(ACTIONS[`platform_support_${action}`], {
            value: {
                email,
                display_name,
                message
            }
        });
    };
  
    const handleSupportMessage = async () => {
        setLoad(true);
        handleRudderStack(_user.email, _user.display_name,supportData.message, "attempt");
        const resp = await api.helpscout_message(token, supportData.subject, supportData.type,_user.display_name, supportData.billing_email, _user.email, supportData.endpoint, supportData.chain, supportData.message);
        if (resp && resp.error) {
            setLoad(false);
            handleRudderStack(_user.email, _user.display_name,supportData.message, "failed");
            
            return handleToast({
                error: resp.error,
                error_message: resp.error_message
            });
        }
        handleRudderStack(_user.email, _user.display_name,supportData.message, "success");

        handleToast({
            title: "Successfully created support ticket."
        });
        setSubmit(true);
        setLoad(false);

    };

    if (!router.isReady) {
        return <PageLoad />;
    }

    return ( <><Flex justify={"between"} align={"center"}>
        <BreadCrumb title={"Support"} />
    </Flex>
    <Flex direction={"column"}>
        <h2>Premium support</h2>
        <Card size="4">
            <Flex direction={"column"} gap="3">
                <p>Providing the details specified below will expedite your support request.</p>
                <Select placeholder="Please select type of problem" label="Select type of problem" id="referral_origin" onChange={(e) => {
                    setData({ ...supportData, ...{ type: e.target.value } });
                } }>
                    <option value="API">API</option>
                    <option value="BILLING">Billing</option>
                    <option value="OTHER">Other</option>
                </Select>
                <Input label="Name" disabled value={_user.display_name} />
                <Input label="Email" disabled value={_user.email} />
                <Input required value={supportData.subject} label="Subject" placeholder="Please include subject of your issue" onChange={(e) => {
                    setData({ ...supportData, ...{ subject: e.target.value } });
                } } />
                {supportData.type === "API" ?
                    <>
                        <Input value={supportData.chain} required label="Chain (name or id)" placeholder="Please include the name or ID of the chain you are calling" onChange={(e) => {
                            setData({ ...supportData, ...{ chain: e.target.value } });
                        } } />
                        <Input value={supportData.endpoint} required label="Endpoint" placeholder="Please include the endpoint you are calling" onChange={(e) => {
                            setData({ ...supportData, ...{ endpoint: e.target.value } });
                        } } />
                    </>
                    : supportData.type === "BILLING" ?
                        <Input required value={supportData.billing_email} label="Billing email" placeholder="Please include billing email associated to your subscription" onChange={(e) => {
                            setData({ ...supportData, ...{ billing_email: e.target.value } });
                        } } />
                        : <></>}
                <div>
                    <label>Message <span> *</span></label>
                    <textarea name="message" value={supportData.message} placeholder="Message" onChange={(e) => {
                        setData({ ...supportData, ...{ message: e.target.value } });
                    } } />
                </div>
                <Button load={load} fill disabled={load || _createSupportFormNotOk() || submitted} onClick={handleSupportMessage}>{submitted ? "Successfully created ticket" : "Submit"}</Button>
            </Flex>
        </Card>
    </Flex>
    <style jsx>
        {`
              .form{
                display:flex;
                flex-direction: column;
                gap:1rem;
              }
              span{
                color: var(--red);
              }
              .disabled{
                background:#F2F2F2;
                color:#868E96;
              }
              .input-container{
                display:flex;
                flex-direction: column;
                gap:4px;
              }
              .fill{
                width:100%;
                flex-grow:1;
              }
              input, textarea {
                margin-bottom: 0.75rem;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                padding: 16px;
                gap: 10px;
                width: 100%;
                font-size:var(--font-size-3);
                height: 48px;
                background: #FFFFFF;
                border: 1px solid var( --border-color);
                border-radius: 4px;
                flex: none;
                order: 1;
                align-self: stretch;
                flex-grow: 0;
              }
              textarea {
                height: 200px;
              }
              label{
                font-size:var( --font-size-2);
                margin-bottom: 0.5rem;
              }
              .small input {
                padding: .5rem .75rem;
                border-radius: var(--border-radius);
                border: 1px solid var(--code-border);
                margin-left: auto;
                flex: 1 1 0%;
                font-size: var(--font-size-2);
              }
              .small .disabled {
                background: var(--code-background);
              }
        .platform-page{
          height: calc(100vh - var(--top-platform-nav-height));
          width:100vw;
          overflow:auto;
          width: 100%;
        }
        .ch-hr {
          margin-bottom: 2rem;
        }
        .carousel-button {
          background: var(--pink);
          display: flex;
          place-items: center;
          padding: 9px 8px;
          margin: -10px;
        }
        .carousel-button:hover {
          background: black;
        }
        .gap {
          margin-top: 1rem;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        h2 {
          margin-bottom: 1rem;
        }
        .clickable{
          color: var(--pink);
        }
        .clickable:hover{
          cursor:pointer;
        }
        .flex {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .hr-auth {
          margin-left: 2rem;
          margin-right: 2rem;
        }

        .top {
          max-width: 1440px;
          padding: 0rem;
          margin-top: 2rem;
        }
        .flex div:first-of-type {
          flex: 1 1 60%;
        }
        .flex div:last-of-type {
          flex: 1 1 0%;
        }
        .title-side {
          display: flex;
          align-items:center;
          gap:5px;
          margin: 0rem 0 1rem 0;
          color:black;
        }
        .title-side span{
          font-size:30px;
        }
        .title-side h2{
          margin:0;
        }
        .title-side a {
          color: var(--pink);
          text-decoration: none;
          font-family: ${tw.style.fontFamily} , sans-serif;
        }

        .chart-buttons {
          display: flex;
          place-items: center;
          border-radius: var(--border-radius);
          overflow: hidden;
          cursor: pointer;
        }
        
        .chart-buttons .selected {
          background: var(--pink);
          padding: 10px 10px 5px 10px;
          color: white;
        }
        
        .chart-buttons div:not(.selected) {
          padding: 10px 10px 5px 10px;
          background: white;
          color: black;
          stroke: black;
        }

        .chart-buttons div:hover {
          background: black !important;
          color: white !important;
        }

        .main {
          padding: 2rem;
          padding-top: 0;
          display: flex;
          width: 100%;
          // background: var(--gray);
          gap: 2rem;
          // overflow: auto;
          flex-wrap: wrap;
          max-width: 1440px;
        }

        .overflow {
          background: var(--gray);
          width: 100vw;
          height: 100vh;
          position: sticky;
          top: 0;
          min-width: 0;
          flex: 1 1 0%;
        }

        .col {
          flex: 1 1 0px;
          width: 100%;
          min-width: 200px;
          // max-width: 470px;
        }

        .covalent-logo {
          width: 100%;
          padding: 1.5rem 2rem;
          color: white;
          display: flex;
          place-items: center;
          gap: 0.5rem;
          font-family: ${tw.style.fontFamily} , sans-serif;
          font-size: var(--font-size-4)
        }

        .cards-wrapper {
          display: flex;
          gap: 1rem;
          margin-top: 1rem;
          flex-wrap: wrap;
        }

        .link-wrapper {
          display: flex;
          gap: 1rem;
          // margin-top: 1rem;
          flex-wrap: wrap;
          flex-direction: column;
        }

        .wrapper {
          display: flex;
        }

        .posts-wrapper {
          
          // background: white;
          border-radius: var(--border-radius);
          // width: 100%;
          // box-shadow: 0px 0px 20px -18px;
          border-radius: var(--border-radius);
          // max-width: 572px;
        }

        .card{
          margin-top: 1rem;
        }
      `}
    </style>
    </>);
};

export default withAuth(withPlatformLayout(SupportPage));
